module.exports = __webpack_public_path__ + "img/instagram-icon-wit.48eebedae40cf13c67f86ff99340bccc.svg";